import { Action,createFeatureSelector,createSelector } from '@ngrx/store';
import {ExerciseModule} from './traning.module'
import * as fromRoot from '../app.reducer';
import {SET_AVAILABLE_TRANING,traningAction,SET_FINISHED_TRANING,START_TRANING,STOP_TRANING} from './traning.actions';

export interface traningState {

    availableTraning:ExerciseModule[];
    finishedTraning:ExerciseModule[];
    activeTraning:ExerciseModule;
};

export  interface State extends fromRoot.State {
        traning:traningState
};

export const  initialState:traningState = {

    availableTraning:[],
    finishedTraning:[],
    activeTraning:null
}

export function traningReducer(state = initialState, action: traningAction)
{


            switch(action.type)
            {
                case  SET_AVAILABLE_TRANING:
                        return {
                            ...state,
                            availableTraning:action.payload
                        }
                case SET_FINISHED_TRANING :
                                return {
                                    ...state,
                                    finishedTraning:action.payload
                                }
                case START_TRANING :
                                return {
                                    ...state,
                                    activeTraning:state.availableTraning.find(ex => ex.id === action.payload)
                                }
                case STOP_TRANING :
                                return {
                                    ...state,
                                    activeTraning:null
                                }
                default :
                {
                    return state;
                }
            }



};

export const  AvailableTranings = createFeatureSelector<traningState>('traning');
export const  getAvailableTranings = createSelector(AvailableTranings ,(state:traningState ) => state.availableTraning);

export const  FinishedTraning = createFeatureSelector<traningState>('traning');
export const getFinishedTraning =createSelector(FinishedTraning ,(state:traningState ) => state.finishedTraning);

export const ActiveTraning = createFeatureSelector<traningState>('traning');
export const getActiveTraning =createSelector(ActiveTraning,(state:traningState )=>state.activeTraning);


export  const getIsActiveTraning = createSelector(ActiveTraning,(state:traningState) => state.activeTraning!=null);